<template>
    <div v-if="showVerticalMenu" class="card m-3 filter-card">
        <div class="card-body p-3 force-secondary bg-data-filter">
            <select-company
                :key="'sc'+key" @company-has-changed="filterHasChanged"/>
            <select-office
                :key="'so'+key" @office-has-changed="filterHasChanged"/>
            <select-collaborator
                :key="'safu'+key" @collaborator-has-changed="filterHasChanged"/>
            <select-role
                :key="'sr'+key" @role-has-changed="filterHasChanged"/>
            <select-end-of-exercise
                :key="'seoe'+key" @end-of-exercise-has-changed="filterHasChanged"
            />
            <select-legal
                :key="'slf'+key"
                :value="filters.legalForms"
                @legal-form-has-changed="filterHasChanged"
            />
            <select-activation
                :key="'sa'+key"
                v-if="showActivationFilter"
                :value="activationFilter"
                @activation-filter-has-changed="filterHasChanged"
            />
            <select-client-group
                :key="'scg'+key"
                :value="filters.clientGroups"
                @client-group-has-changed="filterHasChanged"
            />
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import SelectCompany from '../../activity_management/activity/components/SelectAccountingFirmCompanyNew.vue'
import SelectOffice from '../../activity_management/activity/components/SelectAccountingFirmOffice.vue'
import SelectCollaborator from '../../activity_management/activity/components/AccountingFirmUserSelectNew.vue'
import SelectRole from '../../activity_management/activity/components/SelectRoleNew.vue'
import SelectLegal from '../../activity_management/activity/components/SelectLegalForm.vue'
import SelectClientGroup from '../../activity_management/activity/components/SelectClientGroupForm.vue'
import SelectEndOfExercise from '../../activity_management/activity/components/SelectEndOfExerciseNew.vue'
import SelectActivation from '../../activity_management/activity/components/SelectActivation.vue'
import KeyHandler from '../../activity_management/invoicing/mixins/KeyHandler.vue'

export default {
    name: 'DataFilterNew',

    components: {
        SelectCompany,
        SelectOffice,
        SelectCollaborator,
        SelectRole,
        SelectLegal,
        SelectClientGroup,
        SelectEndOfExercise,
        SelectActivation
    },

    mixins: [KeyHandler],

    props: {
        showActivationFilter: {
            required: false,
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            activationFilter: (state) => state.browsing.clientsActivationFilter,
            showVerticalMenu: (state) => state.reportingVM.showVerticalMenu
        })
    },

    async created() {
        if (!this.showVerticalMenu) {
            await this.$store.dispatch('data/getAllOptions')
            await this.$store.dispatch('reportingVM/getFilters')
            this.$store.commit(
                'todoVM/SET_ACCOUNTING_FIRM_USER_OPTION',
                this.filters.accountingFirmUser
            )
            this.$store.commit('reportingVM/SHOW_VERTICAL_MENU')
        }
        await this.$store.dispatch('reportingVM/getFilters')
        this.updateKey()
    },

    methods: {
        async filterHasChanged() {
            await this.$emit('filter-has-changed')
            await this.$store.dispatch('reportingVM/getFilters')
            this.updateKey()
        }
    }
}
</script>

<style scoped>
.force-secondary :hover {
    color: #343a40 !important;
}

.force-secondary {
    color: #343a40 !important;
}
</style>
